// extracted by mini-css-extract-plugin
module.exports = {"pageLoader":"PageLoader_pageLoader__3K2HL","loading":"PageLoader_loading__186_v"};